var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2144 17.4972H13.5113H8.35499V16.0213H12.7846C12.676 15.4601 12.2029 15.0374 11.6362 15.0374H9.76124C9.65249 15.0374 9.54468 15.0108 9.44718 14.9596L6.7828 13.5615H2.26123V12.0856H6.94874H7.11468L7.2628 12.1633L9.92718 13.5615H11.6362C12.68 13.5615 13.5786 14.2121 13.9842 15.148L18.5631 13.9381C19.6569 13.6488 20.8042 14.1393 21.3925 15.1511L21.3931 15.1521L22 16.191L11.6795 22L2 17.9364L2.52227 16.5661L11.5928 20.374L19.9817 15.6522C19.6969 15.3797 19.2947 15.2666 18.9068 15.3692L14.2144 16.6092V16.7593V17.4972Z",
    fill: "#B3C2D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66859 2.13008C7.27546 2.61418 6.59015 4.30852 7.13577 5.91528C7.68234 7.52107 11.6358 10.8556 11.6358 10.8556C11.6358 10.8556 15.5892 7.52107 16.1358 5.91528C16.6814 4.30852 15.9961 2.61418 14.603 2.13008C14.0077 1.92292 13.3794 1.9709 12.8126 2.21927C12.3671 2.41444 11.9596 2.73336 11.6358 3.14944C11.3119 2.73336 10.9044 2.41444 10.459 2.21927C9.89214 1.9709 9.2639 1.92292 8.66859 2.13008Z",
    fill: "#B3C2D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrant);
export default __webpack_public_path__ + "static/media/Grant.50284c974fd048efbd99e1abc7c5286d.svg";
export { ForwardRef as ReactComponent };